import padrao, { ReactComponent as Padrao } from "../img/padrão.svg";
import jejum, { ReactComponent as Jejum, TempoJejum } from "../img/Jejum.svg";
import material, { ReactComponent as Material } from "../img/material.svg";
import informaçosInternas, {
  ReactComponent as InformaçosInternas
} from "../img/InformacoesInternas.svg";
import condicoes, { ReactComponent as Condicoes } from "../img/Condições.svg";
import marcacao, { ReactComponent as Marcacao } from "../img/Marcação.svg";
import instrucoes, { ReactComponent as Instrucoes } from "../img/Instrucoes.svg";
import atendeEmDomicílio, {
  ReactComponent as AtendeEmDomicílio
} from "../img/AtendeEmDomicílio.svg";
import exigeAgendamento, { ReactComponent as ExigeAgendamento } from "../img/Exige_Agendamento.svg";
import exameSobSedacao, { ReactComponent as ExameSobSedacao } from "../img/exameSobSedacao.svg";
import recomendacoesImportantes, {
  ReactComponent as RecomendacoesImportantes
} from "../img/Recomendacoes_importantes.svg";
import preco, { ReactComponent as Preco } from "../img/Preço_particular.svg";
import programaUrgencia, { ReactComponent as ProgramaUrgencia } from "../img/programaUrgencia.svg";
import volumeMinimo, { ReactComponent as VolumeMinimo } from "../img/volumeMinimo.svg";
import volumeRecomendado, {
  ReactComponent as VolumeRecomendado
} from "../img/volumeRecomendado.svg";
import conservacaoFilial, {
  ReactComponent as ConservacaoFilial
} from "../img/conservacaoFilial.svg";
import coletaFilial, { ReactComponent as ColetaFilial } from "../img/coletaFilial.svg";
import criteriosRejeicao, {
  ReactComponent as CriteriosRejeicao
} from "../img/criteriosRejeicao.svg";
import lojasServico, { ReactComponent as LojasServico } from "../img/lojasServico.svg";
import formatoResultado, { ReactComponent as FormatoResultado } from "../img/formatoResultado.svg";
import indicacoes, { ReactComponent as Indicacoes } from "../img/indicacoes.svg";
import composicao, { ReactComponent as Composicao } from "../img/composicao.svg";
import fabricante, { ReactComponent as Fabricante } from "../img/fabricante.svg";
import esquemaAplicacao, { ReactComponent as EsquemaAplicacao } from "../img/esquemaAplicacao.svg";
import efeitosAdversos, { ReactComponent as EfeitosAdversos } from "../img/efeitosAdversos.svg";
import contraIndicacoes, { ReactComponent as ContraIndicacoes } from "../img/contraIndicacoes.svg";
import eficacia, { ReactComponent as Eficacia } from "../img/eficacia.svg";
import calendario, { ReactComponent as Calendario } from "../img/calendario.svg";
import fonteValorReferencia, {
  ReactComponent as FonteValorReferencia
} from "../img/fonteValorReferencia.svg";
import regraAgendamentoOrcamento, {
  ReactComponent as RegraAgendamentoOrcamento
} from "../img/RegraAgendamentoOrcamento.svg";
import precoL2L, { ReactComponent as PrecoL2L } from "../img/precoL2L.svg";
import codigoProcedimento, {
  ReactComponent as CodigoProcedimento
} from "../img/codigoProcedimento.svg";
import outrosLaboratorios, {
  ReactComponent as OutrosLaboratorios
} from "../img/outrosLaboratorios.svg";
import coletaApoio, { ReactComponent as ColetaApoio } from "../img/coletaApoio.svg";
import conservacaoApoio, { ReactComponent as ConservacaoApoio } from "../img/conservacaoApoio.svg";

export const ambiente = {
  producao: { codigo: "producao" },
  homologacao: { codigo: "homologacao" },
  rollout: { codigo: "rollout" },
  desenvolvimento: { codigo: "desenvolvimento" },
  local: { codigo: "local" }
};

export const categoriaExameInformacao = {
  Imagem: 1,
  AnalisesClinicas: 2,
  Vacinas: 3,
  Veterinario: 4,
  Informativo: 5,
  Todos: 9,
  NaoAssociados: 10
};

export const unidadeDeNegocio = {
  Geral: 1,
  L2L: 2,
  PSC: 3
};

export const listaUnidadeDeNegocio = [
  { descricao: "Geral", id: 1 },
  { descricao: "L2L", id: 2 },
  { descricao: "PSC", id: 3 }
];

export const listaDeOpcoesFiltroLayout = [
  { descricao: "Todos", id: 9 },
  { descricao: "Imagem", id: 1 },
  { descricao: "Análises Clínicas", id: 2 },
  { descricao: "Vacinas", id: 3 },
  { descricao: "Veterinário", id: 4 },
  { descricao: "Informativo", id: 5 }
];

export const tipoServicoExame = {
  Imagem: "DIDM",
  AnalisesClinicas: "AC",
  Vacinas: "VAC",
  Veterinario: "VET",
  Informativo: "INF"
};

export const nomeTipoServicoExame = {
  DIDM: "Imagem",
  AC: "Análises Clínicas",
  VAC: "Vacinas",
  VET: "Veterinário",
  INF: "Informativo"
};

export const situacaoExame = {
  Publicado: 1,
  AguardandoPublicacao: 0
};

export const categoriaAnalytcs = {
  HelpExamesInterno: "Help Exames - Interno",
  HelpExamesExterno: "Help Exames - Externo"
};

export const deParaDescricaoNomeArquivoIcones = {
  padrao: { src: padrao, componente: Padrao },
  Jejum: { src: jejum, componente: Jejum },
  "Tempo de Jejum": { src: jejum, componente: TempoJejum },
  Material: { src: material, componente: Material },
  "Informações Internas": { src: informaçosInternas, componente: InformaçosInternas },
  Condições: { src: condicoes, componente: Condicoes },
  Marcação: { src: marcacao, componente: Marcacao },
  "Preço particular": { src: preco, componente: Preco },
  Instruções: { src: instrucoes, componente: Instrucoes },
  "Atende em Domicílio": { src: atendeEmDomicílio, componente: AtendeEmDomicílio },
  "Exige Agendamento?": { src: exigeAgendamento, componente: ExigeAgendamento },
  "Exame realizado sob sedação": { src: exameSobSedacao, componente: ExameSobSedacao },
  "Informações sobre o exame": { src: padrao, componente: Padrao },
  "Recomendações importantes": {
    src: recomendacoesImportantes,
    componente: RecomendacoesImportantes
  },
  "Programa de urgência": { src: programaUrgencia, componente: ProgramaUrgencia },
  "Volume Mínimo": { src: volumeMinimo, componente: VolumeMinimo },
  "Volume Recomendável": { src: volumeRecomendado, componente: VolumeRecomendado },
  "Conservação Filial": { src: conservacaoFilial, componente: ConservacaoFilial },
  "Coleta Filial": { src: coletaFilial, componente: ColetaFilial },
  "Critérios de Rejeição": { src: criteriosRejeicao, componente: CriteriosRejeicao },
  "Lojas que disponibilizam o serviço": { src: lojasServico, componente: LojasServico },
  "Formato de Resultado": { src: formatoResultado, componente: FormatoResultado },
  Indicações: { src: indicacoes, componente: Indicacoes },
  Composição: { src: composicao, componente: Composicao },
  "Esquema Aplicação": { src: esquemaAplicacao, componente: EsquemaAplicacao },
  Fabricante: { src: fabricante, componente: Fabricante },
  "Eventos Adversos": { src: efeitosAdversos, componente: EfeitosAdversos },
  "Contra Indicação": { src: contraIndicacoes, componente: ContraIndicacoes },
  Eficácia: { src: eficacia, componente: Eficacia },
  Calendário: { src: calendario, componente: Calendario },
  "Fonte do Valor de Referência": { src: fonteValorReferencia, componente: FonteValorReferencia },
  "Regra para agendamento e orçamento": {
    src: regraAgendamentoOrcamento,
    componente: RegraAgendamentoOrcamento
  },
  "Preço L2L": {
    src: precoL2L,
    componente: PrecoL2L
  },
  "Código Procedimento": {
    src: codigoProcedimento,
    componente: CodigoProcedimento
  },
  "Outros Laboratórios ": {
    src: outrosLaboratorios,
    componente: OutrosLaboratorios
  },
  "Coleta Apoio": {
    src: coletaApoio,
    componente: ColetaApoio
  },
  "Conservação Apoio": {
    src: conservacaoApoio,
    componente: ConservacaoApoio
  }
  // TODO: adicionar ícones para "Questionário" e "Via de admministração"
};

export const tipoEstruturaCodigo = {
  1: "IM",
  2: "AC",
  3: "VAC",
  4: "VET",
  5: "INF"
};

export const tipoOperacao = {
  Insert: "I",
  Update: "U",
  Delete: "D"
};

export const diasAlteracao = 5;

export const obterTipoOperacaoAtributoConsolidadoExame = tipo => {
  if (tipo === tipoOperacao.Insert) return { texto: "Inseriu no exame", cor: "#5EC0C733" };
  else return { texto: "Removeu do exame", cor: "#D3124526" };
};

export const timerSessaoExpiracao = {
  IntervalMs: 60 * 1000, // valor em milissegundos
  TempoRenovarSessaoEmMinutos: 10
};
